import React from "react";
import { SafeAreaView, ScrollView, StyleSheet, View } from "react-native";

import WebFooter from "@/Components/Footers/Web/WebFooter";
import MenuBar from "@/Components/Headers/MenuBar";
import { themes } from "@/Components/Styling/themeConfigs";
import { useGoogleAnalytics } from "@/hooks/analytics";

type Props = {
  children: React.ReactNode;
};

function PageLayout({ children }: Props): React.JSX.Element {
  const currentTheme = themes.morning;
  useGoogleAnalytics();

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: currentTheme.backgroundColor,
    },
    menuWrapper: {
      width: "100%",
      alignItems: "center",
      borderBottomWidth: 1,
      borderBottomColor: currentTheme.borderColor,
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.05,
      shadowRadius: 1,
      elevation: 1,
    },
    menuInner: {
      width: "100%",
      maxWidth: 1280,
    },
    children: {
      flex: 1,
      alignItems: "center",
      width: "100%",
      height: "100%",
      backgroundColor: currentTheme.backgroundColor,
    },
    content: {
      flex: 1,
      top: 16,
      maxWidth: 1280,
    },
    footer: {
      marginTop: 20,
    },
  });

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.menuWrapper}>
        <View style={styles.menuInner}>
          <MenuBar />
        </View>
      </View>
      <View style={styles.children}>
        <ScrollView contentContainerStyle={styles.content}>
          {children}
          <View style={styles.footer}>
            <WebFooter />
          </View>
        </ScrollView>
      </View>
    </SafeAreaView>
  );
}

export default PageLayout;
